<div class="mat-modal-dialog manageMasterRoutePreview-modal">
  <h2 mat-dialog-title>
    <span class="material-icons-outlined"
      style="color: #FF0000; font-size: 20px; position: relative; top: 5px; margin-right: 10px;">
      info</span> <span style="color: #FF455B; font-size: 15px; font-weight: 500; font-family: poppins;">Preview</span>
    <span class="material-icons-outlined"
      style="color:#FF0000; font-size: 25px; float: right; position: relative; top: 10px; cursor: pointer;"
      (click)="onClickCancel()">
      close</span>
  </h2>
</div>

<div class="map-card">
  <div id="map"></div>
</div>